<template>
<div id="users">
    <vue-headful title="Users" />
    <v-container fluid style="background-color: #f5f5f5;" :class="{ 'px-1': $vuetify.breakpoint.smAndDown, 'pt-3': true}">

        <v-row no-gutters>
            <!-- Organization typefilter-->
            <v-col cols="12" md="3" class="px-1">
                <v-card class="mb-3 elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Organization type</div>
                    <v-select class="im-select pa-0 ma-0" flat solo v-model="organization_type" :items="organization_types" placeholder="Any" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}" @input="getItems()" hide-details />

                </v-card>
            </v-col>
            <!--./ Organization type filter-->
            <!-- Organization filter-->
            <v-col cols="12" md="3" class="px-1">
                <v-card class="mb-3 elevation-1 pa-2">
                    <div class="detail font-weight-bold pa-0 ma-0">Organization</div>
                    <im-organization-search class="im-select pa-0 ma-0" placeholder="Type here to select ..." @input="filterOrganization($event)" hide-details />

                </v-card>
            </v-col>
        </v-row>

        <!-- SEARCH -->
        <div class="im-search mt-3 mb-1">
            <div class="d-flex">
                <v-text-field class="ma-0 mx-1 white pt-0" flat v-model="search" clearable placeholder="Type here to search by field ..." append-icon="search" hide-details></v-text-field>
                <v-icon v-if="$vuetify.breakpoint.smAndDown" class="px-1" medium @click="dialog_mobile_sort = true">swap_vert
                </v-icon>
            </div>
            <div class="d-flex mx-1 py-2 fields align-center">
                <span class="detail mr-1 hidden-sm-and-down">Find in:</span>
                <v-btn class="mx-1" v-for="field in search_fields" :key="field.value" small rounded depressed :color="field.selected ? 'primary' : 'grey lighten-2'" :text-color="field.selected ? 'white' : 'grey'" @click="selectField(field)">
                    <span class="text-capitalize caption">{{field.text}}</span>
                </v-btn>
            </div>
        </div>
        <!-- ./ SEARCH -->

        <!--data table-->
        <v-card tile flat class="mx-1">
            <im-table-header class="mt-2" :items="im_header" @clickSort="sortField($event)" />
        </v-card>
        <!--./ data table -->
        <div class="mx-1" style="position: relative; height: 3px">
            <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
        </div>

        <!-- DATATABLE ROWS -->
        <v-card tile flat class="mx-1" style="background-color: transparent !important;">
            <v-data-iterator :items="items" :page.sync="page" :items-per-page.sync="size" :server-items-length="total" :footer-props="{ itemsPerPageOptions }">
                <template v-slot:default="props">
                    <template v-for="item in props.items">
                        <im-user-item :item="item" @click.native="openEditModal(item)" :key="item.id" />
                    </template>
                </template>
                <template v-slot:no-data>
                    <v-alert :value="true" type="info" color="primary">
                        No data available.
                    </v-alert>
                </template>
            </v-data-iterator>
        </v-card>
    </v-container>


    <im-user-modal :dialog="dialog_user" :item_id="item_id" @exit="dialog_user=false, item_id=null,getItems()"></im-user-modal>

    <!-- add user button -->
    <v-btn color="primary elevation-16" fab large fixed bottom right @click="openCreateUserModal()">
        <v-icon>add</v-icon>
    </v-btn>
    <!-- ./ add user button -->

    <!-- dialog mobile sort -->
    <v-dialog v-model="dialog_mobile_sort" max-width="300px">
        <v-card>
            <v-card-text class="important">
                Sort Items by
            </v-card-text>
            <im-sort-filed :items="im_header" @clickSort="sortField($event)"></im-sort-filed>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="dialog_mobile_sort = false">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- ./ dialog dialog mobile sort -->

</div>
</template>

<script>
import {
    mapActions
} from 'vuex';
import defaults from "../../components/utils/PropDefaults.js";
import IMOrganizationSearch from "../../components/utils/OrganizationSearch.vue";
import IMTableHeader from "../../components/utils/IMTableHeader.vue";
import IMSortField from "../../components/utils/IMSortField.vue";
import IMUserItem from "../../components/items/Users/Card.vue";
import IMUserModal from "../../components/items/Users/Modal.vue";

export default {
    components: {
        "im-organization-search": IMOrganizationSearch,
        "im-table-header": IMTableHeader,
        "im-sort-filed": IMSortField,
        "im-user-item": IMUserItem,
        "im-user-modal": IMUserModal,
    },

    data() {
        return {
            //item model
            service: {},
            roles: [],
            user: this.$clone(defaults.user_item),
            delete_user_id: null,
            item_id: null,

            // search
            search: null,
            search_timeout: 500,
            search_fields: [
                {
                    text: "ID",
                    value: "user_id",
                    selected: true
                }, {
                    text: "First Name",
                    value: "first_name",
                    selected: true
                }, {
                    text: "Last Name",
                    value: "last_name",
                    selected: true
                }, {
                    text: "Email",
                    value: "email",
                    selected: false
                }
            ],

            // modals
            role_dialog: false,
            dialog_mobile_sort: false,
            edit_dialog: false,
            add_dialog: false,
            dialog_user: false,

            // users table
            sort_field_item: null,
            sort_field_dir: null,
            loading: false,
            total: 0,
            page: 1,
            size: 10,
            itemsPerPageOptions: [10, 25, 50, 100],
            im_header: [
                {
                    text: "Name",
                    width: "25%",
                    sortable: true,
                    sort_order: "first_name",
                    sort_dir: null
                }, {
                    text: "Organization",
                    width: "25%",
                    sortable: false
                }, {
                    text: "Contact",
                    width: "33.4%",
                    sortable: false
                }, {
                    text: "Created at",
                    width: "16.6%",
                    sortable: true,
                    sort_order: "created_at",
                    sort_dir: null
                }
            ],

            //props
            items: [],
            // date filters
            created_at_after: null,
            created_at_before: null,
            last_logged_in_after: null,
            last_logged_in_before: null,

            // organization_types
            filter_organization_id: null,
            organization_type: null,
            organization_types: [
                {
                    text: "None",
                    value: "none"
                }, {
                    text: "Supplier",
                    value: "supplier"
                }, {
                    text: "Agency",
                    value: "agency"
                }, {
                    text: "Operator",
                    value: "operator"
                }, {
                    text: "Master",
                    value: "master"
                }
            ],
        };
    },

    watch: {
        page: {
            handler() {
                this.getItems();
            }
        },
        size: {
            handler() {
                this.getItems();
            }
        },
        search: {
            handler() {
                this.page = 1;
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.getItems, 200);
            }
        }
    },

    created() {
        this.getItems();
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        openCreateUserModal() {
            this.item_id = null;
            this.dialog_user = true;
        },

        getItems() {
            // we are currently loading
            this.loading = true;

            // prepare search string
            let search = this.search;
            if(search === "" || search === undefined) {
                search = null;
            }

            //prepare sorting & direction params
            let orders = [];
            let dirs = [];
            if(this.sort_field_item) {
                dirs.push(this.sort_field_dir);
                orders.push(this.sort_field_item);
            }

            // prepare type filter
            let fields = [];
            this.search_fields.forEach(field => {
                if(field.selected) {
                    fields.push(field.value);
                }
            });
            // prepare oraganization filter
            let organization_ids = null;
            if(this.filter_organization_id) {
                organization_ids = [this.filter_organization_id];
            }

            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/profiles/users";

            // setup query params
            let params = {
                params: {
                    search: search,
                    fields: fields,
                    size: this.size,
                    page: this.page,
                    order: orders,
                    dir: dirs,
                    stamp: stamp,
                    // operational fields
                    organization_ids: organization_ids,
                    organization_type: this.organization_type,
                    created_at_after: this.created_at_after,
                    created_at_before: this.created_at_before,
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    // if the current stamp matches the received stamp, populate items
                    if(parseInt(this.current_stamp) === parseInt(response.data.meta.stamp)) {
                        this.items = response.data.data;
                        this.total = response.data.pagination.total;
                    }
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        // dialog functions
        openEditModal(current_user) {
            this.item_id = current_user.id;
            this.dialog_user = true;
            // this.user = current_user;
        },

        // sort and search funtions
        selectField(field) {
            field.selected = !field.selected;
            if(this.search) {
                this.page = 1;
                this.getItems();
            }
        },

        sortField(sortItem) {
            this.sort_field_item = sortItem.sort_order;
            this.sort_field_dir = sortItem.sort_dir;
            this.page = 1;
            this.getItems();
            this.dialog_mobile_sort = false;
        },

        // filetrs functions
        filterOrganization(organization) {
            this.filter_organization_id = null;
            if(organization) {
                this.filter_organization_id = organization.id;
            }
            this.page = 1;
            this.getItems();
        },

        formatDate(value) {
            if(!value) return value;
            return this.$moment(String(value))
                .format("DD MMM YY");
        },

    }
};
</script>
